import { ChartProps, Doughnut as CharJSDoughnut } from 'react-chartjs-2'

import { useIntl } from '@context/Internationalization/useIntl'
import Theme from '@theme'
import { tooltipValueToPercentage } from '@tribegroup/Charts/util'

interface IDoughnut {
  data: {
    label: string
    value: number
    percentage: number
  }[]
  showAsPercentage?: boolean
  isEmpty?: boolean
}

export const AnalyticsAudienceReportingChartsDoughnut: React.FC<IDoughnut> = ({
  data,
  showAsPercentage,
  isEmpty,
}) => {
  const { intl } = useIntl()

  if (isEmpty) {
    return (
      <CharJSDoughnut
        key="empty"
        data={{
          datasets: [
            {
              data: [1],
              backgroundColor: [Theme.grey300Color],
              borderWidth: 0,
            },
          ],
        }}
        options={{
          aspectRatio: 2,
          cutout: '75%',
          plugins: {
            tooltip: {
              enabled: false,
            },
            subtitle: {
              display: true,
              position: 'bottom',
              padding: { top: 20 },
              text: intl.formatMessage({ id: 'audienceInsights.chart.empty' }),
              color: Theme.grey700Color,
              font: {
                family: 'Rubik',
                size: 14,
              },
            },
            legend: {
              display: false,
            },
          },
        }}
      />
    )
  }

  const records = data.sort((firstEl, secondEl) => (firstEl.label > secondEl.label ? 1 : -1))
  const dataSet = records.map(({ value }) => value)

  const config: ChartProps<'doughnut'>['data'] = {
    labels: records.map(({ label }) => label),
    datasets: [
      {
        data: dataSet,
        backgroundColor: [Theme.primaryColor, Theme.secondary500Color, Theme.successColor],
      },
    ],
  }

  return (
    <CharJSDoughnut
      key="data"
      data={{
        ...config,
      }}
      options={{
        aspectRatio: 2,
        cutout: '75%',
        plugins: {
          tooltip: {
            callbacks: {
              label: (data) => {
                return `${data.label}: ${
                  showAsPercentage ? tooltipValueToPercentage(data) : data.formattedValue
                }`
              },
              title: () => '',
            },
          },
          legend: {
            display: true,
            position: 'bottom',
            fullSize: true,
            labels: {
              font: {
                family: 'Rubik',
                size: 14,
              },
              color: Theme.grey700Color,
            },
          },
        },
      }}
    />
  )
}
